export const dynamicPricing = {
  title: "Tarification dynamique",
  loading: "Chargement des paramètres…",
  status: {
    active: "Activé",
    inactive: "Désactivé",
  },
  close: "Fermer",
  unit: {
    label: "Logement",
    autoPill: "✦ Auto d'après votre historique",
  },
  tabs: {
    calendario: "Calendrier",
    precio: "Prix de base",
    reglas: "Règles",
    aplicacion: "Application",
  },
  weekdaysShort: {
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Jeu",
    fri: "Ven",
    sat: "Sam",
    sun: "Dim",
  },
  cal: {
    stats: {
      adr: "ADR proj.",
      occupancy: "Occupation",
      revenue: "Revenu",
    },
    calculating: "Calcul des prix…",
    minStayShort: "min. {count}n | min. {count}n",
  },
  legend: {
    low: "Bas",
    base: "Base",
    high: "Élevé",
    peak: "Pointe",
    booked: "Réservé",
    override: "Fixe",
  },
  why: {
    title: "Pourquoi {price} {curr} · {day}",
    chip: "explication",
    nights: "{count} nuit | {count} nuits",
    minStay: "Séjour minimum : {nights} · plancher {floor} / plafond {ceil} {curr}",
    hint: "Appuyez sur un jour pour voir le détail de son prix.",
  },
  apply: {
    diffPrefix: "Avec les prix suggérés :",
    diffSuffix: "par rapport à vos prix actuels pour {month}.",
    apply: "Appliquer les prix",
    applying: "Application…",
    applyNow: "Appliquer maintenant",
    enableToApply: "Activez la tarification dynamique pour appliquer.",
    enableFirst: "Activez d'abord la tarification dynamique.",
    autoNote: {
      prefix: "✓ En mode",
      mode: "Automatique,",
      mid: "les prix s'appliquent",
      everyday: "tous les jours",
    },
    result: {
      hotelPending: "Les hôtels (plusieurs unités) ne sont pas encore pris en charge à ce stade.",
      ok: "✓ {count} jour appliqué ({from} → {to}) et envoyé aux canaux. | ✓ {count} jours appliqués ({from} → {to}) et envoyés aux canaux.",
      failed: "Impossible d'appliquer les prix.",
    },
  },
  base: {
    title: "Prix de base et limites",
    desc: "Suggéré d'après votre historique. Le moteur ne sort jamais de cette plage.",
    basePerNight: "Base / nuit",
    min: "Minimum (plancher)",
    max: "Maximum (plafond)",
    rounding: "Arrondi",
  },
  rounding: {
    integer: "Entier",
    ends0: "Finit par 0",
    ends9: "Finit par 9",
    multiple5: "Mult. 5",
  },
  weekend: {
    title: "Week-end et séjour minimum",
    upliftLabel: "Majoration week-end",
    daysLabel: "Jours de week-end :",
    minStayLabel: "Séjour minimum (nuits)",
    minStayNormal: "Standard",
    minStayWeekend: "Week-ends / haute saison",
    orphanTitle: "Combler les nuits orphelines",
    orphanDesc: "Séjours plus courts ({pct} % de remise) dans les trous de 1–2 nuits.",
  },
  demand: {
    title: "Sensibilité à la demande",
    desc: "Dans quelle mesure l'occupation et le rythme des réservations font varier le prix.",
  },
  aggr: {
    low: "Prudent",
    medium: "Moyen",
    high: "Agressif",
  },
  seasons: {
    title: "Saisons",
    namePlaceholder: "Nom",
    monthDayPlaceholder: "MM-DD",
    add: "+ Ajouter une saison",
  },
  events: {
    title: "Événements (foires, festivals…)",
    suggestWithAI: "✨ Suggérer avec l'IA",
    suggesting: "Recherche…",
    namePlaceholder: "Nom",
    datePlaceholder: "YYYY-MM-DD",
    empty: "Aucun événement. Ajoutez-les manuellement ou avec l'IA.",
    add: "+ Ajouter un événement",
    suggestionsHead: "Suggestions de l'IA{city} — vérifiez les dates et ajoutez",
    addSuggestion: "+ Ajouter",
    noSuggestions: "Aucune suggestion (vérifiez que le logement a une ville définie).",
  },
  demandRules: {
    title: "Règles de demande",
    lastMinuteTitle: "Remises de dernière minute",
    lastMinuteDesc: "Réduit le prix des dates proches encore disponibles.",
    holidaysTitle: "Jours fériés automatiques",
    holidaysDesc: "Applique +{pct} % les jours fériés nationaux.",
    occupancyTitle: "Augmenter selon l'occupation",
    occupancyDesc: "Si le mois est rempli à plus de {threshold} %, augmenter le prix.",
    weeklyDiscount: "Remise hebdo. (7+) %",
    monthlyDiscount: "Remise mens. (28+) %",
  },
  application: {
    title: "Mode et synchronisation",
    modeLabel: "Mode d'application",
    modeSuggested: "Suggéré (je vérifie d'abord)",
    modeAuto: "Automatique",
    syncTitle: "Synchroniser avec les canaux (Channex → Airbnb / Booking)",
    syncDesc: "Publie les prix calculés sur vos canaux.",
    horizonLabel: "Horizon de calcul",
    horizonMonths: "{count} mois",
  },
  save: {
    saved: "Enregistré ✓",
    saving: "Enregistrement…",
    save: "Enregistrer les modifications",
  },
  errors: {
    forbidden: "Vous n'avez pas accès à ce logement.",
    loadFailed: "Impossible de charger les paramètres.",
    saveFailed: "Impossible d'enregistrer. Vérifiez les champs.",
  },
};
